export const CONFIG = {
  SERVER: process.env.REACT_APP_NODE_SERVER,
};
console.log(CONFIG);
